import React from "react"
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip"
import ClickAwayListener from "@mui/material/ClickAwayListener"
import PropTypes from "prop-types"
import styled from "@emotion/styled"

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme, textSx, bgColor }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: bgColor || theme.palette.background.default,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: bgColor || theme.palette.background.default,
    // color: "rgba(0, 0, 0, 0.87)",
    color: theme.palette.common.black,
    opacity: 0.87,
    boxShadow:
      "0 2px 4px 0 rgb(34 36 38 / 12%), 0 2px 10px 0 rgb(34 36 38 / 15%)",
    fontSize: 14,
    padding: ".833em 1em",
    ...textSx,
  },
}))

export default function LightTooltip({ setTooltipOpen, divStyle, ...props }) {
  return (
    <ClickAwayListener
      onClickAway={() => {
        if (props?.open === undefined || setTooltipOpen === undefined) {
          return
        }
        setTooltipOpen(false)
      }}
    >
      <div style={divStyle}>
        <CustomTooltip {...props}>{props.children}</CustomTooltip>
      </div>
    </ClickAwayListener>
  )
}

LightTooltip.propTypes = {
  children: PropTypes.node.isRequired,
}
